import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Header, Grid } from 'semantic-ui-react';
import classNames from 'classnames';

import { DroppableAreaEnum } from 'Pages/productionreportsetup/helpers/Constants';
import { sortOptions } from 'Pages/productionreportsetup/helpers/dnd';

function ReportOptions({ options, title }) {
  const reportOptions = React.useMemo(() => options.sort(sortOptions), [options]);
  return (
    <React.Fragment>
      <Header as="h3">{title}</Header>
      <Droppable droppableId={DroppableAreaEnum.OptionsSection}>
        {(provided, snapshot) => (
          <div style={{minHeight: '100%'}} ref={provided.innerRef} {...provided.droppableProps}>
            {reportOptions.map((option, i) => (
              <Grid.Row key={i}>
                <Grid.Column>
                  <Draggable
                    index={i}
                    key={option.Id}
                    draggableId={`${option.Id}`}
                  >
                    {(provided, snapshot) => {
                      return (
                        <div
                          className={classNames(
                            'cprt-grid-cell',
                            snapshot.isDragging && 'cprt-grid-cell-dragging',
                            option.Required && 'required'
                          )}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div className="grip" />
                          <span>{option.Description}</span>
                        </div>
                      );
                    }}
                  </Draggable>
                </Grid.Column>
              </Grid.Row>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </React.Fragment>
  );
}

export { ReportOptions };



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/createreporttemplate/components/ReportOptions.js